package adapters

import myConst.StorageAdaptersSealed
import myConst.fromJsonToString
import myConst.fromStringToStorage
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.toSelectedCategory
import ui.themePlusContext.ThemesMode
import utils.logger.log
import web.dom.document
import web.storage.Storage
import web.storage.localStorage
import web.storage.sessionStorage

object Storage {

    fun getNameOrSet(
        v:String? = null
    ): String {
        v?.let {
            setItemOrNull(StorageConst.NAME_KEY.keyL, it)
            return getItemOrDefault(StorageConst.NAME_KEY.keyL, StorageConst.NAME_KEY.def)
        } ?: run {
            return getItemOrDefault(StorageConst.NAME_KEY.keyL, StorageConst.NAME_KEY.def)
        }
    }
    fun getCategoryOrSet(
        v:SelectedCategory? = null
    ): SelectedCategory {
        v?.let {
            setItemOrNull(StorageConst.CATEGORY_KEY.keyL, it.toString())
            return getItemOrDefault(StorageConst.CATEGORY_KEY.keyL, StorageConst.CATEGORY_KEY.def).toSelectedCategory()
        } ?: run {
            return getItemOrDefault(StorageConst.CATEGORY_KEY.keyL, StorageConst.CATEGORY_KEY.def).toSelectedCategory()
        }
    }
    fun getThemeOrSet(
        v:ThemesMode? = null
    ): ThemesMode {
        v?.let {
            setItemOrNull(StorageConst.THEME_KEY.keyL, it.toString())
            return getItemOrDefault(StorageConst.THEME_KEY.keyL, StorageConst.THEME_KEY.def).toThemeMode()
        } ?: run {
            return getItemOrDefault(StorageConst.THEME_KEY.keyL, StorageConst.THEME_KEY.def).toThemeMode()
        }
    }

    fun getMainListOrSet(
        v:StorageAdaptersSealed.MainList? = null
    ): StorageAdaptersSealed.MainList? {
        v?.let {
            setItemOrNull(StorageConst.MAIN_LIST_KEY.keyL, it.fromJsonToString() , sessionStorage)
            return getItemOrDefault(StorageConst.MAIN_LIST_KEY.keyL, StorageConst.MAIN_LIST_KEY.def, sessionStorage).fromStringToStorage() as StorageAdaptersSealed.MainList?
        } ?: run {
            return getItemOrDefault(StorageConst.MAIN_LIST_KEY.keyL, StorageConst.MAIN_LIST_KEY.def, sessionStorage).fromStringToStorage() as StorageAdaptersSealed.MainList?
        }
    }

    private fun getItemOrDefault(
        keyL: String,
        default: String,
        str: Storage = localStorage
    ): String{
        val objK = str.getItem(keyL)
        if (objK == null){
            val asd = setItemOrNull(keyL, default, str)
            return default
        }else{
            val a = str.getItem(keyL) ?: default
            return a
        }
    }

    private fun setItemOrNull(
        key: String,
        default: String,
        str: Storage = localStorage
    ): Boolean{
        return try {
            str.setItem(key, default)
            true
        }catch (_: Exception){
            log.d("setItemOrNull | error")
            false
        }
    }

    enum class StorageConst(
        val keyL: String,
        val def: String
    ){
        NAME_KEY(
            keyL = "name_key",
            def = "^_-"
        ),
        CATEGORY_KEY(
            keyL = "category_key",
            def = SelectedCategory.NONE.toString()
        ),
        THEME_KEY(
            keyL = "theme_key",
            def = ThemesMode.LIGHT.toString()
        ),
        MAIN_LIST_KEY(
            keyL = "main_list_key",
            def = "{}"
        ),
        SCHEDULE_LIST_KEY(
            keyL = "schedule_list_key",
            def = "{}"
        )
    }

    private fun String.toThemeMode(): ThemesMode{
        return when(this){
            "LIGHT" -> ThemesMode.LIGHT
            "DARK" -> ThemesMode.DARK
            else -> ThemesMode.LIGHT
        }
    }
}